<template>
    <div class="page-contact">
        <slot name="mantel"></slot>

        <div class="page-contact__container container">
            <div class="page-contact__form-container">
                <div class="justify-content-center">
                    <slot name="form"></slot>
                </div>
            </div>

            <div class="page-contact__cards">
                <slot name="contact-cards"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import Mantel from '@/components/Mantel';

    export default {
        name: 'Contact',

        components: { Mantel },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .page-contact {
        margin: 0 0 3rem;

        &__container {
            display: flex;
            flex-direction: column;

            padding-top: 1.5rem;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                padding-top: 6rem;
            }

            @media screen and (min-width: map_get($grid-breakpoints, 'md')) {
                flex-direction: row;
            }
        }

        &__form-container {
            margin-bottom: 6rem;
            padding:    5rem 1.5rem;

            background: $white;
            border:     0.1rem solid $gray-300;

            @media screen and (min-width: map_get($grid-breakpoints, 'sm')) {
                padding: 3rem 10rem 5rem;
            }

            @media screen and (min-width: map_get($grid-breakpoints, 'md')) {
                width: 72.5rem;
                margin-right: 6rem;
            }
        }

        &__cards {
            @media screen and (min-width: map_get($grid-breakpoints, 'md')) {
                flex: 1;
                width: 100%;
            }
        }

        // Pas de BEM pour styler ContactForm 7 parce qu'on a pas la main sur le markup. Cool !
        .wpcf7-form {
            display:        flex;
            flex-direction: column;

            p {
                display: flex;
            }

            .wpcf7-form-control {
                display:   flex;
                flex-grow: 1;
            }

            .wpcf7-form-control-wrap {
                display:        flex;
                flex-direction: column;
                flex-grow:      1;

                margin-top:     0.5rem;

                // Field validation error message
                .wpcf7-not-valid-tip {
                    margin-top:     0.5rem;
                    text-transform: none;
                }
            }

            .wpcf7-list-item {
                flex-grow: 1;
                margin:    0;

                label {
                    font-size:      1.8rem;
                    text-transform: none;
                }
            }

            .newsletter-consent {
                margin: 0 auto;

                label {
                    font-size: 1.2rem;
                }
            }

            .rounded-button {
                flex-grow: 0;
                margin:    0 auto;

                cursor:    pointer;
            }

            .wpcf7-text,
            .wpcf7-textarea {
                padding:   0.6rem 1.5rem;

                border:    0.1rem solid $gray-400;

                font-size: 1.8rem;
            }

            .wpcf7-not-valid {
                border: 0.2rem solid red;
            }

            label {
                flex:           1 1 auto;
                width:          100%; // FIXME: Trouver mieux

                font-size:      1.2rem;
                text-transform: uppercase;

                cursor:         pointer;
            }

            .wpcf7-response-output,
            .wpcf7-validation-errors {
                margin:     0 0 5rem;
                padding:    0;

                border:     none;

                order:      -1;

                color:      red;
                font-size:  1.2rem;
                text-align: center;
            }

            // Custom radio control
            $custom-form-controls-color: $gray-600; // Don't forget to change the color of the src/assets/images/custom-checkbox-checkmark.svg as well
            .wpcf7-radio,
            .wpcf7-checkbox {
                .wpcf7-list-item-label {
                    position:    relative;

                    display:     flex;
                    align-items: center;

                    margin:      2rem 3rem 2rem 0;
                    padding: 1rem 0 1rem 3rem;

                    &::before {
                        content:   '';

                        position:  absolute;
                        left:      0;
                        top:       50%;
                        transform: translateY(-50%);

                        width:     2rem;
                        height:    2rem;

                        border:    0.2rem solid $custom-form-controls-color;
                    }
                }

                input:checked + .wpcf7-list-item-label::after {
                    content:   '';
                    position:  absolute;
                    left:      0.4rem;
                    top:       50%;
                    transform: translateY(-50%);

                    width:     1.2rem;
                    height:    1.2rem;
                }

                input[type=radio],
                input[type=checkbox] {
                    opacity:  0;
                    position: absolute;
                }
            }

            .wpcf7-radio {
                .wpcf7-list-item-label::before {
                    border-radius: 50%;
                }

                input:checked + .wpcf7-list-item-label::after {
                    border-radius: 50%;
                    background:    $custom-form-controls-color;
                }
            }

            .wpcf7-checkbox {
                input:checked + .wpcf7-list-item-label::after {
                    background: url(~@/assets/images/custom-checkbox-checkmark.svg) center no-repeat;
                }
            }
        }
    }
</style>
